
import { GET_INNOVATE_USER_IDEAS_FAILURE, GET_INNOVATE_USER_IDEAS_STARTED, GET_INNOVATE_USER_IDEAS_SUCCESS} from "actions/sync/user_profile/Constants"
import { REQUEST_JOIN_IDEA_SUCCESS } from "actions/sync/ideas/ideasActionConstans"
import { GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE,GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS,GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED,ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE, ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED, ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS, ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE, ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED, ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS, DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE, DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED, DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS, DELETE_INNOVATE_IDEA_DOCUMENT_FAILURE, DELETE_INNOVATE_IDEA_DOCUMENT_STARTED, DELETE_INNOVATE_IDEA_DOCUMENT_SUCCESS, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS, GET_IDEA_ID_DETAILS_INNOVATE_FAILURE, GET_IDEA_ID_DETAILS_INNOVATE_STARTED, GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS, GET_INNOVATE_IDEA_TEAM_FAILURE, GET_INNOVATE_IDEA_TEAM_STARTED, GET_INNOVATE_IDEA_TEAM_SUCCESS, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS, GET_INNOVATE_MY_IDEA_FAILURE, GET_INNOVATE_MY_IDEA_STARTED, GET_INNOVATE_MY_IDEA_SUCCESS, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS, INNOVATE_DELETE_USER_FROM_TEAM_FAILURE, INNOVATE_DELETE_USER_FROM_TEAM_STARTED, INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS, POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE, POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED, POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS, POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE, POST_INNOVATE_CREATE_IDEA_EDIT_STARTED, POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS, POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE, POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED, POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS, POST_INNOVATE_IDEA_APPROVE_FAILURE, POST_INNOVATE_IDEA_APPROVE_STARTED, POST_INNOVATE_IDEA_APPROVE_SUCCESS, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS, UPLOAD_INNOVATE_IDEA_DOCUMENT_FAILURE, UPLOAD_INNOVATE_IDEA_DOCUMENT_STARTED, UPLOAD_INNOVATE_IDEA_DOCUMENT_SUCCESS, GET_IDEA_HISTORY_INNOVATE_STARTED, GET_IDEA_HISTORY_INNOVATE_SUCCESS, GET_IDEA_HISTORY_INNOVATE_FAILURE, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE, INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED, INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS, INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE, MOVE_TO_DRAFT_INNOVATE_STARTED, MOVE_TO_DRAFT_INNOVATE_SUCCESS, MOVE_TO_DRAFT_INNOVATE_FAILURE, REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_STARTED, REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_SUCCESS, REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_FAILURE } from "actions/sync/innovate/idea/Constants"

const initialState = {
  isAlreadyInvited:false,
  getInnovateIdeaTemplateIdJsonLoading: false,
  getInnovateCreateIdeaDraftLoading: false,
  getInnovateCreateIdeaPublishLoading: false,
  getInnovateCreateIdeaEditLoading: false,
  getInnovateIdeaDraftIDLoading: false,
  deleteInnovateIdeaDocumentLoading: false,
  getInnovateIdeaDocumentUploadLoading:false,
  getInnovateIdeaImageLoading:false,
  getInnovateIdeaImageDeleteLoading:false,
  getInnovateIdeaIdDetailIsLoading:false,
  getJsonChallengeTemplateIdIsLoading:false,
  getEvaluationDashboardIdeaIsLoading:false,
  getMyEvaluationDashboardIdeaIsLoading:false,
  postApproveIdeaIsLoading:false,
  ifHackthonTrueGetInnovateIdeaIsLoading:false,
  innovateMyIdeaIsLoading:false,
  innovateUserIsEvaluatorOrNotIsLoading:false,
  innovateUserIsEvaluatorOrNot:false,
  getInnovateIdeaTeamIsLoading:false,
  postInnovateIdeaAddTeamMemberIsLoading:false,
  postInnovateIdeaInviteTeamMemberIsLoading:false,
  filterListInnovateChallengeLoading:false,
  postInnovateIdeaSaveRatingIsLoading:false,
  innovateAddBusinessScoreCardIsLoading:false,
  innovateShowPopupEvaluatorAssignedDataIsLoading:false,
  innovateAddBusinessScoreCard:[],
  innovateShowPopupEvaluatorAssignedData:[],
  postInnovateIdeaSaveRating:[],
  filterListInnovateChallenge:[],
  postInnovateIdeaAddTeamMember:[],
  postInnovateIdeaInviteTeamMember:[],
  getInnovateIdeaTeam:[],
  innovateMyIdeaList:[],
  ifHackthonTrueGetInnovateIdea:[],
  postApproveIdea:[],
  getMyEvaluationDashboardIdea:[],
  getEvaluationDashboardIdea:[],
  getJsonChallengeTemplateId:[],
  getInnovateIdeaIdDetail:[],
  getInnovateIdeaImage:[],
  getInnovateIdeaImageDelete:[],
  getInnovateIdeaDocumentUpload:[],
  deleteInnovateIdeaDocument:[],
  getInnovateCreateIdeaDraftData:[],
  getInnovateCreateIdeaEditData:[],
  getInnovateCreateIdeaPublishData:[],
  getInnovateIdeaTemplateIdJson: [],
  getInnovateIdeaDraftID:[],
  ideaHistoryData:[],
  ideaHistoryIsLoading:false,
  InnovateUserIdeasListIsLoading:false,
  InnovateUserIdeasList:[],
  postInnovateIdeaAddBySMEGroupsIsLoading:false,
  postInnovateIdeaAddBySMEGroups:[],
  innovateGetChallengeTaggedIdeaListIsLoading:false,
  innovateGetChallengeTaggedIdeaList:[],
  getMyEvaluationDashboardIdeaHistoryIsLoading: false,
  getMyEvaluationDashboardIdeaHistory: [],
  deleteSelectedUserFromTagIdeaWithThisChallengeIsLoading:false,
  deleteSelectedUserFromTagIdeaWithThisChallenge:[]
}


const InnovateIdeaReducer = (state = initialState, action) => {
  switch (action.type) {

    case ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED:
      return {
        ...state,
        getInnovateIdeaImageLoading: true
      }

    case ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS:
      return {
        ...state,
        getInnovateIdeaImageLoading: false,
        getInnovateIdeaImage: action.response,
      }

    case ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE:
      return {
        ...state,
        getInnovateIdeaImageLoading: false
      }

    case DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED:
      return {
        ...state,
        getInnovateIdeaImageDeleteLoading: true
      }

    case DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS:
      return {
        ...state,
        getInnovateIdeaImageDeleteLoading: false,
        getInnovateIdeaImageDelete: action.response,
      }

    case DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE:
      return {
        ...state,
        getInnovateIdeaImageDeleteLoading: false
      }

    case GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED:
      return {
        ...state,
        getInnovateIdeaTemplateIdJsonLoading: true
      }

    case GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS:
      return {
        ...state,
        getInnovateIdeaTemplateIdJsonLoading: false,
        getInnovateIdeaTemplateIdJson: action.response,
      }

    case GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE:
      return {
        ...state,
        getInnovateIdeaTemplateIdJsonLoading: false
      }

    case POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED:
      return {
        ...state,
        getInnovateCreateIdeaDraftLoading: true
      }

    case POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS:
      return {
        ...state,
        getInnovateCreateIdeaDraftLoading: false,
        getInnovateCreateIdeaDraftData: action.response,
      }

    case POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE:
      return {
        ...state,
        getInnovateCreateIdeaDraftLoading: false
      }

    case POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED:
      return {
        ...state,
        getInnovateCreateIdeaPublishLoading: true
      }

    case POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS:
      return {
        ...state,
        getInnovateCreateIdeaPublishLoading: false,
        getInnovateCreateIdeaPublishData: action.response,
      }

    case POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE:
      return {
        ...state,
        getInnovateCreateIdeaPublishLoading: false
      }

    case POST_INNOVATE_CREATE_IDEA_EDIT_STARTED:
      return {
        ...state,
        getInnovateCreateIdeaEditLoading: true
      }

    case POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS:
      return {
        ...state,
        getInnovateCreateIdeaEditLoading: false,
        getInnovateCreateIdeaEditData: action.response,
      }

    case POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE:
      return {
        ...state,
        getInnovateCreateIdeaEditLoading: false
      }

    case GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED:
      return {
        ...state,
        getInnovateIdeaDraftIDLoading: true
      }

    case GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS:
      return {
        ...state,
        getInnovateIdeaDraftIDLoading: false,
        getInnovateIdeaDraftID: action.response,
        getInnovateIdeaDocumentUpload:[],
      }

    case GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE:
      return {
        ...state,
        getInnovateIdeaDraftIDLoading: false
      }

    case DELETE_INNOVATE_IDEA_DOCUMENT_STARTED:
      return {
        ...state,
        deleteInnovateIdeaDocumentLoading: true
      }

  case DELETE_INNOVATE_IDEA_DOCUMENT_SUCCESS:
  return {
    ...state,
    deleteInnovateIdeaDocumentLoading: false,
    getInnovateIdeaDocumentUpload: action.response,
  }

    case DELETE_INNOVATE_IDEA_DOCUMENT_FAILURE:
      return {
        ...state,
        deleteInnovateIdeaDocumentLoading: false
      }

    case UPLOAD_INNOVATE_IDEA_DOCUMENT_STARTED:
      return {
        ...state,
        getInnovateIdeaDocumentUploadLoading: true
      }

      case UPLOAD_INNOVATE_IDEA_DOCUMENT_SUCCESS: {
        const prev = state.getInnovateIdeaDocumentUpload || []
        const newDoc = action.response
      
        // guard
        if (!newDoc?.key) {
          return {
            ...state,
            getInnovateIdeaDocumentUploadLoading: false,
          }
        }
      
        const exists = prev.some(d => d.key === newDoc.key)
      
        return {
          ...state,
          getInnovateIdeaDocumentUploadLoading: false,
          getInnovateIdeaDocumentUpload: exists
            ? prev
            : [...prev, newDoc],
        }
      }
      
    case UPLOAD_INNOVATE_IDEA_DOCUMENT_FAILURE:
      return {
        ...state,
        getInnovateIdeaDocumentUploadLoading: false
      }


    case GET_IDEA_ID_DETAILS_INNOVATE_STARTED:
      return {
        ...state,
        getInnovateIdeaIdDetailIsLoading: true
      }

    case GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS:
      return {
        ...state,
        getInnovateIdeaIdDetailIsLoading: false,
        getInnovateIdeaIdDetail: action.response,
        getInnovateIdeaDocumentUpload: action.response?.documents ?? [],
      }

    // return {
      //   ...state,
      //   getInnovateIdeaIdDetailIsLoading: false,
      //   getInnovateIdeaIdDetail:action.response,
      // }

    case GET_IDEA_ID_DETAILS_INNOVATE_FAILURE:
      return {
        ...state,
        getInnovateIdeaIdDetailIsLoading: false
      }

      

    case GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED:
      return {
        ...state,
        getJsonChallengeTemplateIdIsLoading: true
      }

    case GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS:
      return {
        ...state,
        getJsonChallengeTemplateIdIsLoading: false,
        getJsonChallengeTemplateId:action.response,

      }
    case GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE:
      return {
        ...state,
        getJsonChallengeTemplateIdIsLoading: false
      }

      

    case GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED:
      return {
        ...state,
        getEvaluationDashboardIdeaIsLoading: true
      }

    case GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS:
      return {
        ...state,
        getEvaluationDashboardIdeaIsLoading: false,
        getEvaluationDashboardIdea:action.response,

      }
    case GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE:
      return {
        ...state,
        getEvaluationDashboardIdeaIsLoading: false
      }


    case GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED:
      return {
        ...state,
        getMyEvaluationDashboardIdeaIsLoading: true
      }

    case GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS:
      return {
        ...state,
        getMyEvaluationDashboardIdeaIsLoading: false,
        getMyEvaluationDashboardIdea:action.response,

      }
    case GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE:
      return {
        ...state,
        getMyEvaluationDashboardIdeaIsLoading: false
      }


    case POST_INNOVATE_IDEA_APPROVE_STARTED:
      return {
        ...state,
        postApproveIdeaIsLoading: true
      }

    case POST_INNOVATE_IDEA_APPROVE_SUCCESS:
      return {
        ...state,
        postApproveIdeaIsLoading: false,
        postApproveIdea:action.response,

      }
    case POST_INNOVATE_IDEA_APPROVE_FAILURE:
      return {
        ...state,
        postApproveIdeaIsLoading: false
      }

      
    case GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED:
      return {
        ...state,
        ifHackthonTrueGetInnovateIdeaIsLoading: true
      }

    case GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS:
      return {
        ...state,
        ifHackthonTrueGetInnovateIdeaIsLoading: false,
        ifHackthonTrueGetInnovateIdea:action.response,
      }
    case GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE:
      return {
        ...state,
        ifHackthonTrueGetInnovateIdeaIsLoading: false
      }
      
    case GET_INNOVATE_MY_IDEA_STARTED:
      return {
        ...state,
        innovateMyIdeaIsLoading: true
      }

    case GET_INNOVATE_MY_IDEA_SUCCESS:
      return {
        ...state,
        innovateMyIdeaIsLoading: false,
        innovateMyIdeaList:action.response,
      }
    case GET_INNOVATE_MY_IDEA_FAILURE:
      return {
        ...state,
        innovateMyIdeaIsLoading: false
      }
    
     case GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED:
      return{
        ...state,
        innovateUserIsEvaluatorOrNotIsLoading:true
      } 
     case GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS:
      return{
        ...state,
        innovateUserIsEvaluatorOrNotIsLoading:false,
        innovateUserIsEvaluatorOrNot:action.response
      } 
     case GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE:
      return{
        ...state,
        innovateUserIsEvaluatorOrNotIsLoading:false
      } 

     case GET_INNOVATE_IDEA_TEAM_STARTED:
      return{
        ...state,
        getInnovateIdeaTeamIsLoading:true
      } 
     case GET_INNOVATE_IDEA_TEAM_SUCCESS:
      return{
        ...state,
        getInnovateIdeaTeamIsLoading:false,
        getInnovateIdeaTeam:action.response
      } 
      case REQUEST_JOIN_IDEA_SUCCESS: {
        return {
          ...state,
          isAlreadyInvited: true,
        }
      }
     case GET_INNOVATE_IDEA_TEAM_FAILURE:
      return{
        ...state,
        getInnovateIdeaTeamIsLoading:false
      } 
     case ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED:
      return{
        ...state,
        postInnovateIdeaAddTeamMemberIsLoading:true
      } 
     case ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS:
      return{
        ...state,
        postInnovateIdeaAddTeamMemberIsLoading:false,
        postInnovateIdeaAddTeamMember:action.response
      } 
     case ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE:
      return{
        ...state,
        postInnovateIdeaAddTeamMemberIsLoading:false
      } 
      
     case INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED:
      return{
        ...state,
        postInnovateIdeaInviteTeamMemberIsLoading:true
      } 
     case INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS:
      return{
        ...state,
        postInnovateIdeaInviteTeamMemberIsLoading:false,
        postInnovateIdeaInviteTeamMember:action.response
      } 
     case INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE:
      return{
        ...state,
        postInnovateIdeaInviteTeamMemberIsLoading:false
      } 

     case POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED:
      return{
        ...state,
        postInnovateIdeaSaveRatingIsLoading:true
      } 
     case POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS:
      return{
        ...state,
        postInnovateIdeaSaveRatingIsLoading:false,
        postInnovateIdeaSaveRating:action.response
      } 
     case POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE:
      return{
        ...state,
        postInnovateIdeaSaveRatingIsLoading:false
      } 

      case PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED:
      return{
        ...state,
        innovateAddBusinessScoreCardIsLoading:true
      } 

     case PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS:
      return{
        ...state,
        innovateAddBusinessScoreCardIsLoading:false,
        innovateAddBusinessScoreCard:action.response
      } 

     case PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE:
      return{
        ...state,
        innovateAddBusinessScoreCardIsLoading:false
      } 

      case GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED:
      return{
        ...state,
        innovateShowPopupEvaluatorAssignedDataIsLoading:true
      } 

     case GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS:
      return{
        ...state,
        innovateShowPopupEvaluatorAssignedDataIsLoading:false,
        innovateShowPopupEvaluatorAssignedData:action.response
      } 

     case GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE:
      return{
        ...state,
        innovateShowPopupEvaluatorAssignedDataIsLoading:false
      } 

      case INNOVATE_DELETE_USER_FROM_TEAM_STARTED:
      return{
        ...state,
        innovateDeleteUserFromTeamIsLoading:true
      } 

     case INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS:
      return{
        ...state,
        innovateDeleteUserFromTeamIsLoading:false,
        innovateDeleteUserFromTeam:action.response
      } 

     case INNOVATE_DELETE_USER_FROM_TEAM_FAILURE:
      return{
        ...state,
        innovateDeleteUserFromTeamIsLoading:false
      } 
      
      case GET_IDEA_HISTORY_INNOVATE_STARTED:
      return{
        ...state,
        ideaHistoryIsLoading:true
      }

      case GET_IDEA_HISTORY_INNOVATE_SUCCESS:
      return{
        ...state,
        ideaHistoryIsLoading:false,
        ideaHistoryData:action.response
      }

      case GET_IDEA_HISTORY_INNOVATE_FAILURE:
      return{
        ...state,
        ideaHistoryIsLoading:false,
        ideaHistoryData:[]
      }

      case MOVE_TO_DRAFT_INNOVATE_STARTED:
      return{
        ...state,
        moveToDraftIsLoading:true
      }

      case MOVE_TO_DRAFT_INNOVATE_SUCCESS:
      return{
        ...state,
        moveToDraftIsLoading:false
      }

      case MOVE_TO_DRAFT_INNOVATE_FAILURE:
      return{
        ...state,
        moveToDraftIsLoading:false
      }

      case GET_INNOVATE_USER_IDEAS_STARTED:
      return {
        ...state,
        InnovateUserIdeasListIsLoading: true,
      }
      case GET_INNOVATE_USER_IDEAS_SUCCESS:
      return {
        ...state,
        InnovateUserIdeasList: action.response,
        InnovateUserIdeasListIsLoading:false,
      }
      case GET_INNOVATE_USER_IDEAS_FAILURE:
      return {
        ...state,
        InnovateUserIdeasListIsLoading: false,
      }


      case INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED:
      return{
        ...state,
        innovateGetChallengeTaggedIdeaListIsLoading:true
      } 

     case INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS:
      return{
        ...state,
        innovateGetChallengeTaggedIdeaListIsLoading:false,
        innovateGetChallengeTaggedIdeaList:action.response
      } 

     case INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE:
      return{
        ...state,
        innovateGetChallengeTaggedIdeaListIsLoading:false
      } 
     
          

      case ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED:
        return{
          ...state,
          postInnovateIdeaAddBySMEGroupsIsLoading:true
        } 
  
       case ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS:
        return{
          ...state,
          postInnovateIdeaAddBySMEGroupsIsLoading:false,
          postInnovateIdeaAddBySMEGroups:action.response
        } 
  
       case ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE:
        return{
          ...state,
          postInnovateIdeaAddBySMEGroupsIsLoading:false
        }

      case GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED:
        return{
          ...state,
          getMyEvaluationDashboardIdeaHistoryIsLoading:true
        }

       case GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS:
        return{
          ...state,
          getMyEvaluationDashboardIdeaHistoryIsLoading:false,
          getMyEvaluationDashboardIdeaHistory:action.response
        }

       case GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE:
        return{
          ...state,
          getMyEvaluationDashboardIdeaHistoryIsLoading:false
        }

      case REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_STARTED:
        return{
          ...state,
          deleteSelectedUserFromTagIdeaWithThisChallengeIsLoading:true
        }

       case REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_SUCCESS:
        return{
          ...state,
          deleteSelectedUserFromTagIdeaWithThisChallengeIsLoading:false,
          deleteSelectedUserFromTagIdeaWithThisChallenge:action.response
        }

       case REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_FAILURE:
        return{
          ...state,
          deleteSelectedUserFromTagIdeaWithThisChallengeIsLoading:false
        }

    default:
      return state
  }
}

export default InnovateIdeaReducer